<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-sendtest"
      scrollable
      centered
      button-size="sm"
      @hidden="onHideModal"
      >
      <template #modal-title>
        <i class="fas fa-user"></i> ENVIAR TESTE
      </template>
      <div class="form-group row">
        <div class="col-md-12">
          <label><small v-show="form.documento.required" class="text-danger">*</small> CPF/CNPJ:</label>
          <div class="input-group">
            <b-form-input type="text"
                            :placeholder="'Digite o CPF ou CNPJ do Contato'"
                            v-model="form.documento.value"
                            :size="form.documento.maxlength"
                            :required="form.documento.required"
                            :state="form.documento.state"
                            v-mask="['###.###.###-##', '##.###.###/####-##']"
                            ></b-form-input>
              <span class="input-group-addon" v-if="false"><i class="fa fa-search"></i></span>
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <label><small v-show="form.nome.required" class="text-danger">*</small> Nome:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o Nome'"
                          v-model="form.nome.value"
                          :size="form.nome.maxlength"
                          :required="form.nome.required"
                          :state="form.nome.state"></b-form-input>
          </div>
        </div>
      </div>
      <div v-if="campanha.plataforma === 1" class="form-group row pt-2">
        <div class="col-md-12">
          <label><small v-show="form.email.required" class="text-danger">*</small> E-mail:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o E-mail'"
                          v-model="form.email.value"
                          :size="form.email.maxlength"
                          :required="form.email.required"
                          :state="form.email.state"></b-form-input>
          </div>
        </div>
      </div>
      <div v-else-if="campanha.plataforma === 2 || campanha.plataforma === 3" class="form-group row pt-2 pb-3">
        <div class="col-md-12">
          <label><small v-show="form.celular.required" class="text-danger">*</small> Celular:</label>
          <div class="input-group">
            <b-form-input type="text"
                          :placeholder="'Digite o Celular'"
                          v-model="form.celular.value"
                          :size="form.celular.maxlength"
                          :required="form.celular.required"
                          :state="form.celular.state"
                          v-mask="['(##) ####-####', '(##) # ####-####']"></b-form-input>
          </div>
        </div>
      </div>
      <div class="form-group row mt-3">
        <div class="col-md-11 ml-3">
          <div class="input-group">
            <b-form-checkbox v-model="form.criarCard.value" switch>
              Abrir card no quadro
            </b-form-checkbox>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <button
            type="button"
            class="btn btn-third btn-sm"
            v-b-tooltip.hover
            :title="'Enviar'"
            :disabled="disableButton"
            @click.prevent="onSave"
          >
            <i class="fas fa-check-circle"></i>
            <span class="d-md-down-none"> Enviar</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import SendTestForm from './sendtest-form.js'
import CampaignRepository from '@/shared/http/repositories/campaign/campaign.js'
import { toast, loading } from '@/shared/utils/UIHelper'
import _ from 'lodash'

const SendTest = {
  campanhaId: null,
  documento: null,
  nome: null,
  email: null,
  celular: null,
  criarCard: true,
  plataforma: null
}

export default {
  name: 'ModalSendTest',
  mixins: [ActionsForm],
  data () {
    return {
      data: _.cloneDeep(SendTest),
      form: _.cloneDeep(SendTestForm),
      disableButton: false,
      campanha: {
        plataforma: null
      }
    }
  },
  methods: {
    showModal (campanha) {
      this.campanha = campanha
      this.data = _.cloneDeep(SendTest)
      this.form = _.cloneDeep(SendTestForm)
      this.setRules()
      this.$refs['modal-sendtest'].show()
    },
    hideModal () {
      this.$refs['modal-sendtest'].hide()
      this.onHideModal()
    },
    onHideModal () {
      this.reset()
    },
    reset () {
      this.campanha = {
        plataforma: null
      }
    },
    setRules () {
      if (this.campanha) {
        this.data.campanhaId = this.campanha.id
        switch (this.campanha.plataforma) {
          case 1:
            this.form.email.required = true
            this.data.plataforma = 1
            break
          case 2:
            this.form.celular.required = true
            this.data.plataforma = 2
            break
          case 3:
            this.form.celular.required = true
            this.data.plataforma = 3
            break
        }
      }
    },
    onCreate () {
      this.onSend()
    },
    onUpdate () {
      this.onSend()
    },
    onSend () {
      loading.push()
      this.disableButton = true
      CampaignRepository.SendTest(this.data)
        .then((response) => {
          toast.success(this.$lang.Common.Alerts.Success)
          this.hideModal()
        })
        .catch(this.onException)
        .finally(() => {
          loading.pop()
          this.disableButton = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/campaign/components/list/modal/emailtestmodal/ModalSendTest.vue